attachEvent('.site-footer__nav-title', 'click', (ev) => {
  if (windowWidth() < breakpointMd) {
    const parentElem = ev.target.closest('.site-footer__nav');
    const content = parentElem.querySelector('.site-footer__nav-dropdown');
    parentElem.classList.toggle('is-open');
    slideToggle(content, 300, 'block');
  }
});
